import { IconsSize, IconsStyle } from '../../enums';

const IconMenuComponent = ({
  size,
  style,
  color,
}: {
  size: IconsSize;
  style: IconsStyle;
  color: string;
}) => {
  return style === IconsStyle.OUTLINE ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4.47619C2 4.2132 2.2132 4 2.47619 4H21.5238C21.7868 4 22 4.2132 22 4.47619C22 4.73918 21.7868 4.95238 21.5238 4.95238H2.47619C2.2132 4.95238 2 4.73918 2 4.47619Z"
        fill={color}
      />
      <path
        d="M2 12.1917C2 11.9287 2.2132 11.7155 2.47619 11.7155H21.5238C21.7868 11.7155 22 11.9287 22 12.1917C22 12.4547 21.7868 12.6679 21.5238 12.6679H2.47619C2.2132 12.6679 2 12.4547 2 12.1917Z"
        fill={color}
      />
      <path
        d="M2.47619 19.4306C2.2132 19.4306 2 19.6438 2 19.9068C2 20.1698 2.2132 20.383 2.47619 20.383H21.5238C21.7868 20.383 22 20.1698 22 19.9068C22 19.6438 21.7868 19.4306 21.5238 19.4306H2.47619Z"
        fill={color}
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4.1087C2 3.81465 2.11415 3.53265 2.31735 3.32473C2.52055 3.11681 2.79614 3 3.0835 3H20.9165C21.2039 3 21.4795 3.11681 21.6826 3.32473C21.8858 3.53265 22 3.81465 22 4.1087C22 4.40274 21.8858 4.68474 21.6826 4.89266C21.4795 5.10058 21.2039 5.21739 20.9165 5.21739H3.0835C2.79614 5.21739 2.52055 5.10058 2.31735 4.89266C2.11415 4.68474 2 4.40274 2 4.1087ZM2 11.5C2 11.206 2.11415 10.924 2.31735 10.716C2.52055 10.5081 2.79614 10.3913 3.0835 10.3913H20.9165C21.2039 10.3913 21.4795 10.5081 21.6826 10.716C21.8858 10.924 22 11.206 22 11.5C22 11.794 21.8858 12.076 21.6826 12.284C21.4795 12.4919 21.2039 12.6087 20.9165 12.6087H3.0835C2.79614 12.6087 2.52055 12.4919 2.31735 12.284C2.11415 12.076 2 11.794 2 11.5ZM3.0835 17.7826C2.79614 17.7826 2.52055 17.8994 2.31735 18.1073C2.11415 18.3153 2 18.5973 2 18.8913C2 19.1854 2.11415 19.4674 2.31735 19.6753C2.52055 19.8832 2.79614 20 3.0835 20H20.9165C21.2039 20 21.4795 19.8832 21.6826 19.6753C21.8858 19.4674 22 19.1854 22 18.8913C22 18.5973 21.8858 18.3153 21.6826 18.1073C21.4795 17.8994 21.2039 17.7826 20.9165 17.7826H3.0835Z"
        fill={color}
      />
    </svg>
  );
};

export default IconMenuComponent;
